import FormHelperText, {
  FormHelperTextProps,
} from "@mui/material/FormHelperText";
import { Controller, useFormContext } from "react-hook-form";
import { RhfProps } from "./types/RhfProps";
import { RhfStyleProps } from "./types/RhfStyleProps";
import { useTranslation } from "react-i18next";

type Props = RhfProps & RhfStyleProps & FormHelperTextProps;

const RhfErrorText = ({
  rhf,
  name,
  defaultValue,
  rules, // RhfProps
  sx,
  className,
  style, // RhfStyleProps
  ...props // FormHelperTextProps
}: Props) => {
  const formContext = useFormContext();
  const { t } = useTranslation();

  if (rhf == null) {
    rhf = formContext; // 優先使用外面傳入的 rhf，否則使用 formContext
  }

  return (
    <Controller
      control={rhf?.control}
      name={name}
      // defaultValue={(defaultValue == null ? "" : defaultValue)} // 不能使用，否則會干擾初始值

      render={({ fieldState }) => {
        // 等同於: render={({ field: { onChange, onBlur, value, ref } }) => (
        const has_error = !!fieldState.error;
        console.log(fieldState.error?.message ?? "");
        return (
          <FormHelperText
            {...props} // FormHelperTextProps
            sx={sx}
            className={className}
            style={style}
            // {...field} 不是 input，只是用來顯示 error，不使用 ...field
            error={has_error}
          >
            {has_error ? t(fieldState.error?.message ?? "") : undefined}
          </FormHelperText>
        );
      }}
    />
  );
};

export default RhfErrorText;
